var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container portfolio-list" },
    [
      _vm.tokens.length
        ? [
            _c(
              "md-list",
              { staticClass: "scrollbar transparent" },
              [
                _vm._l(_vm.tokens, function(token, i) {
                  return [
                    _c(
                      "md-list-item",
                      {
                        key: i,
                        staticClass: "portfolio-list__item",
                        class: {
                          selected:
                            _vm.selected && _vm.selected.code === token.code
                        },
                        on: {
                          click: function($event) {
                            return _vm.selectToken(token)
                          }
                        }
                      },
                      [
                        _c(
                          "md-avatar",
                          { staticClass: "item__avatar" },
                          [
                            token.logoUrl
                              ? [
                                  _c("img", {
                                    attrs: {
                                      src: token.logoUrl,
                                      alt: _vm.avatar(token.code)
                                    }
                                  })
                                ]
                              : [_vm._v(_vm._s(_vm.avatar(token.code)))]
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "item__details" }, [
                          _c(
                            "span",
                            { staticClass: "text_large" },
                            [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(token.code) +
                                  "\n                      "
                              ),
                              _c("company-name-getter", {
                                attrs: { id: token.owner }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _c("div", { staticClass: "text_x_small" }, [
                              _c("span", [
                                _vm._v(_vm._s(_vm.i18n.lbl_available()) + ":")
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(token.availableBalance) +
                                    " " +
                                    _vm._s(token.code)
                                )
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v("~")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(token.convertedBalance) +
                                    " " +
                                    _vm._s(token.convertedAsset)
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "text_x_small" }, [
                              _c("span", [
                                _vm._v(_vm._s(_vm.i18n.lbl_locked()) + ":")
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(token.lockedBalance) +
                                    " " +
                                    _vm._s(token.code)
                                )
                              ])
                            ])
                          ])
                        ])
                      ],
                      1
                    )
                  ]
                })
              ],
              2
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e312b4a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e312b4a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/portfolio/Portfolio.List.vue
// module id = nKHi
// module chunks = 1